import { render, staticRenderFns } from "./showTCaptcha.vue?vue&type=template&id=c40207ca&scoped=true"
import script from "./showTCaptcha.vue?vue&type=script&lang=js"
export * from "./showTCaptcha.vue?vue&type=script&lang=js"
import style0 from "./showTCaptcha.vue?vue&type=style&index=0&id=c40207ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@0.28.11_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.99.6_webpack-cli@4.10.0_/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40207ca",
  null
  
)

export default component.exports